import { addPurchaseNinetailedEvent } from 'webapp/ninetailed/tracking';
import { addToDataLayer, type DataLayerEvent } from '..';
import {
  cartToDataLayerInfo,
  convertProductToGA4,
  itemPriceToDataLayerInfo,
  getRetailMediaSessionId,
  getUserId,
  getTrackingTimestamp,
} from '../utils';

const purchaseOrderSentToDataLayerKey = 'purchase-order-sent-to-data-layer';

export async function addPurchaseEvent(page: NordicNest.Api.OrderConfirmationPageApiModel) {
  const json = localStorage.getItem(purchaseOrderSentToDataLayerKey);
  const orderIds: string[] = json ? JSON.parse(json) : [];
  const { orderId } = page;
  if (orderIds.includes(orderId)) {
    return;
  }

  if (page.trackingData) {
    const trackingData = page.trackingData;
    const ga4Event: DataLayerEvent = {
      event: 'purchase',
      ecommerce: {
        ...(await cartToDataLayerInfo(trackingData.order)),
        revenueInSek: Number(trackingData.order.revenueInSek?.toFixed(2)),
        taxInSek: Number(trackingData.order.taxInSek?.toFixed(2)),
        shippingInSek: Number(trackingData.order.shippingInSek?.toFixed(2)),
        transaction_id: trackingData.order.orderNumber,
        customer_email: trackingData.order.customerEmail,
        items: trackingData.items.map((item, i) => ({
          ...convertProductToGA4(item.trackingProductInformation ?? {}, {}, i),
          ...itemPriceToDataLayerInfo(item.price, item.quantity),
          priceInSek: Number(item.priceInSek?.toFixed(2)),
          quantity: item.quantity,
        })),
        retail_media_session_id: getRetailMediaSessionId(),
        timestamp: getTrackingTimestamp(),
      },
      cart_id: trackingData.order.cartId,
      externalId: getUserId(),
    };
    addToDataLayer(ga4Event);
    addPurchaseNinetailedEvent(trackingData.order.subTotal?.inclVat);
  }

  orderIds.push(orderId);
  localStorage.setItem(purchaseOrderSentToDataLayerKey, JSON.stringify(orderIds));
}
